import { NumberController } from "./number.controller";

export class CurrencyController extends NumberController {

    onInit(): void {
        this.component.prefix = this._getCurrencySymbol();

        super.onInit();
    };

    setup(args: any) {
        super.setup(args);
    }

    public _getCurrencySymbol(): string {
        let language = (window.navigator as any).userLanguage || window.navigator.language;

        switch (language) {
            case 'en-US':
                return '$';
            default:
                return '$';
        }
    }
}